<template>
<span>
    <slot></slot>
    <locations :class="className"
               :hoveredKey="hoveredKey"
               :googleMapsKey="googleMapsKey"
               :style="cssStyle"
               :values="values"></locations>
</span>
</template>

<script>
import { mapBus } from '../utils/map-bus'

export default {
    props: {
        className: {
            type: String,
            _descr: 'Classes of map block',
        },
        cssStyle: {
            type: String,
            _descr: 'Styles of map block',
        },
        googleMapsKey: {
            type: String,
            _descr: 'Google Maps API key',
        },
    },
    data () {
        return {
            values: [],
            hoveredKey: null,
        }
    },
    mounted () {
        mapBus.$on('highlight', key => {
            this.hoveredKey = key
        })

        Array.from(this.$el.querySelectorAll('[data-location]')).forEach((element, index) => {
            this.values.push({
                id: String(index),
                items: [element.getAttribute('data-id')],
                map: {
                    info: element.innerHTML,
                    position: {
                        longitude: element.getAttribute('data-longitude'),
                        latitude: element.getAttribute('data-latitude'),
                    },
                },
            })
        })
    },
    components: {
        locations: require('./locations.vue').default,
    },
}
</script>
